import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 13h14","key":"svg-0"}],["path",{"d":"M5 17h14","key":"svg-1"}],["path",{"d":"M5 7.686c2.333 -2.624 4.667 -1.856 7 .064s4.667 2.688 7 .064","key":"svg-2"}]]

const IconCongruentTo = createReactComponent('outline', 'congruent-to', 'CongruentTo', __iconNode);

export default IconCongruentTo;